<template>
  <div class="formBirthday">
    <input type="hidden" :name="name" :value="val" v-validate:val="validation">

    <div
      class="formBirthday__box"
      :class="[
        { 'formBirthday__box--focus': isActive },
        { 'formBirthday__box--error': errors.has(name) },
      ]"
    >
      <input
        type="tel"
        ref="year"
        :placeholder="placeholderYear"
        class="formBirthday__input formBirthday__input--year"
        maxlength="4"
        v-model="inputYear"
        :name="'year'"
        :data-error="errors.has(name)"
        @input="changeNext(inputYear,'year')"
        @click="selectAll($event.target)"
        @focus="onMouseInput(inputYear,'year')"
        @blur="outMouseInput(inputYear,'year')"
        autocomplete="off"
      >

      <span class="formBirthday__slash" :class="{'formBirthday__slash--on': slashAfterYear}">/</span>

      <input
        type="tel"
        ref="month"
        :placeholder="placeholderMonth"
        class="formBirthday__input formBirthday__input--month"
        maxlength="2"
        v-model="inputMonth"
        :name="'month'"
        :data-error="errors.has(name)"
        @input="changeNext(inputMonth,'month')"
        @click="selectAll($event.target)"
        @focus="onMouseInput(inputMonth, 'month')"
        @blur="outMouseInput(inputMonth, 'month')"
        autocomplete="off"
      >

      <span class="formBirthday__slash" :class="{'formBirthday__slash--on': slashAfterMonth}">/</span>

      <input
        type="tel"
        ref="day"
        :placeholder="placeholderDay"
        class="formBirthday__input formBirthday__input--day"
        maxlength="2"
        v-model="inputDay"
        :name="'day'"
        :data-error="errors.has(name)"
        @input="changeNext(inputDay,'day')"
        @click="selectAll($event.target)"
        @focus="onMouseInput(inputDay, 'day')"
        @blur="outMouseInput(inputDay, 'day')"
        autocomplete="off"
      >
    </div>
    <p v-show="errors.first(name)" class="formBirthday__error">
      {{ errors.first(name) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'formBirthday',
  data() {
    return {
      inputYear: this.substrBirthday(this.value, 'year'),
      inputMonth: this.substrBirthday(this.value, 'month'),
      inputDay: this.substrBirthday(this.value, 'day'),
      isActive: false,
      buildBirthday: '',
      inputValue: '',
      slashAfterYear: true,
      slashAfterMonth: true,
      firstValidate: false
    }
  },
  watch: {
    // 商品購入時に登録情報から生年月日を取得(遅れて取得されるためwatch処理)
    value() {
      if (this.value != undefined) {
        this.inputValue = this.inputValue == '' ? this.value : ''
        if (this.value.length == 8) {
          this.inputYear = this.substrBirthday(this.value, 'year')
          this.inputMonth = this.substrBirthday(this.value, 'month')
          this.inputDay = this.substrBirthday(this.value, 'day')
        }
      }
    }
  },
  props: {
    placeholderYear: String,
    placeholderMonth: String,
    placeholderDay: String,
    valueYear: String,
    valueMonth: String,
    valueDay: String,
    value: String,
    name: String,
    validation: {
      type: [String, Object],
      default: () => ({
        rules: {}
      })
    },
  },
  computed: {
    val() {
      this.buildBirthday = this.inputYear + this.inputMonth + this.inputDay
      if(this.firstValidate) {
        // this.$emit('input', this.buildBirthday)
        this.$emit('change', this.buildBirthday, this.$validator.errors.items.length > 0)
      }
      this.firstValidate = true
      return this.checkOnlyNum(this.buildBirthday)
    }
  },
  mounted() {
    this.controlSlashAfterYear(this.inputYear)
    this.controlSlashAfterMonth(this.inputMonth)
  },
  methods: {
    substrBirthday(val, target) {
      var fullDate = ''
      if (val != undefined) {
        if (val.length == 8) {
          switch (target) {
            case 'year':
              fullDate = val.substr(0, 4)
              break

            case 'month':
              fullDate = val.substr(4, 2)
              break

            case 'day':
              fullDate = val.substr(6, 2)
              break
          }
        }
      }
      return fullDate
    },

    changeNext(val, target) {
      // 月が一桁かつ1,0ではない時、頭に０をつける。
      if (target === 'month') {
        if (val.length === 1 && val.match(/[2-9]/)) val = this.zeropadding(val)
        this.inputMonth = this.checkOnlyNum(val)
        // 何年何月何日のvalueを更新
        this.reduceValue()
        // 更新された値からスラッシュを制御
        this.controlSlashAfterMonth(this.inputMonth)
        this.slashAfterMonth = this.inputMonth.length !== 2 ? false : true
      }
      // 日が一桁かつ1,2,3,0ではない時、頭に０をつける。
      if (target === 'day') {
        if (val.length === 1 && val.match(/[4-9]/)) val = this.zeropadding(val)
        this.inputDay = this.checkOnlyNum(val)
        // 何年何月何日のvalueを更新
        this.reduceValue()
      }
      if (target === 'year') {
        this.inputYear = this.checkOnlyNum(val)
        // 何年何月何日のvalueを更新
        this.reduceValue()
        // 更新された値からスラッシュを制御
        this.slashAfterYear = this.inputYear.length !== 4 ? false : true
      }

      const targetMap = { year: 4, month: 2, day: 2 }
      var checkNums = this.checkOnlyNum(val)

      if (checkNums.length >= targetMap[target]) {
        switch (target) {
          case 'year':
            const targetMonth = this.$refs.month
            targetMonth.focus()
            this.selectAll(targetMonth)
            break

          case 'month':
            // 12より大きい場合はfocusを動かさない。
            if (val > 12) {
              break
            }

            const targetDay = this.$refs.day
            targetDay.focus()
            this.selectAll(targetDay)
            break
        }
      }
    },

    onMouseInput(val, state) {
      this.isActive = true
      if (state === 'year') this.slashAfterYear = val.length !== 4 ? false : true
      if (state === 'month') this.slashAfterMonth = val.length !== 2 ? false : true
    },

    outMouseInput(val, state) {
      this.isActive = false

      // 月日が一桁の時かつ0でない時、頭に０をつける
      if (/^[1-9]$/.test(val) && state === 'day') {
        this.inputDay = this.zeropadding(this.inputDay)
      }
      if (/^[1-9]$/.test(val) && state === 'month') this.inputMonth = this.zeropadding(this.inputMonth)
      if (state === 'month') this.controlSlashAfterMonth(this.inputMonth)
      if (state === 'year') this.controlSlashAfterYear(this.inputYear)
      return this.reduceValue()
    },

    selectAll(target) {
      target.setSelectionRange(0, target.value.length)
    },

    checkOnlyNum(date) {
      return date.replace(/[^0-9]/g, '')
    },

    zeropadding(num) {
      if (num.length === 1) {
        return '0' + num
      }
    },
    reduceValue() {
      // 3つのプロパティを含めた値を監視
      const value = [this.$data.inputYear, this.$data.inputMonth, this.$data.inputDay]
      this.inputValue = value.reduce((total, add) => total + add)
    },
    controlSlashAfterYear(val) {
      // 年が4桁入力されたら、スラッシュ表示
      this.slashAfterYear = /^[04]$/.test(val.length) ? true : false
    },
    controlSlashAfterMonth(val) {
      // 月が2桁入力されたら、スラッシュ表示
      this.slashAfterMonth = /^[02]$/.test(val.length) ? true : false
    }
  }
}
</script>

<style lang="scss" scoped>
.formBirthday {
  margin: 0 0 10px;
  &__box {
    display: flex;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid #DCDFE2;
    height: 40px;
    text-align: center;
    padding-left: 4px;
    transition: 0.2s;
    &--focus {
      border-color: #1b1761;
    }
    &--error {
      background-color: #fff4f5;
    }
  }
  &__input {
    appearance: none;
    border: none;
    padding: 9px 1px 8px;
    text-align: center;
    flex-basis: 2.5em;
    width: 2.5em;
    min-width: auto;
    line-height: 20px;
    outline: none;
    background: none;
    &::placeholder {
      color: #DCDFE2;
    }
    &--year {
      flex-basis: 4em;
      width: 4em;
    }
  }
  &__slash {
    margin-left: -6px;
    position: relative;
    right: -4px;
    line-height: normal; // apple系デバイスのplaceholder文字ずれ防止
    padding: 10px 0 8px;
    top: -1px;
    color: #DCDFE2;
    &--on {
      color: inherit;
    }
  }
  &__error {
    color: #FF7497;
    font-size: 13px;
    margin: 0;
    margin-top: 6px;
    line-height: 20px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/formBirthday.vue